export default __webpack_public_path__ + "static/media/Leggings of Lunacy.4a6ff041.jpg";